import { useEffect } from 'react'
import { useSEO } from '@/contexts/SEOContext'

interface PageSEOProps {
  title: string
  description: string
  keywords?: string
  path: string
  noIndex?: boolean
  structuredData?: object
}

export function usePageSEO({
  title,
  description,
  keywords,
  path,
  noIndex,
  structuredData,
}: PageSEOProps) {
  const { updateSEO } = useSEO()

  useEffect(() => {
    const url = `https://www.jeridschool.com${path}`

    updateSEO({
      title,
      description,
      keywords,
      ogUrl: url,
      canonicalUrl: url,
      noIndex,
      structuredData,
    })
  }, [description, keywords, noIndex, path, structuredData, title, updateSEO])
}
